import $ from 'jquery';
import instagramSquared from 'pxu-instagram-squared';

export default class DynamicInstagramFeed {
  constructor(section) {
    this.settings = section.data;
    this.onboarding = this.settings.onboarding;
    this.photoCount = this.settings.photo_count;
    this.accessToken = this.settings.access_token;
    this.squareImages = this.settings.square_images;

    this.$el = $(section.el);
    this.$photoContainer = this.$el.find('[data-instagram-content]');
    this.$wrapper = this.$el.find('[data-instagram-wrapper]');
    this.$contentPlaceholder = this.$el.find('[data-instagram-photo-placeholder]');

    this.$photoTemplate = $('<figure class="instagram--photo" data-instagram-photo />');

    if (this.onboarding || !this.accessToken) {
      return;
    }

    this._getPhotos()
      .done((photos) => this._renderPhotos(photos))
      .fail((error) => {
        console.warn(`Instagram: ${ error }`);
      });
  }

  _extractWrapperClass() {
    const wrapperClass = this.$wrapper.attr('class').match(/instagram--photo-count-\d+$/);

    if (wrapperClass) {
      return wrapperClass[0];
    } else {
      return '';
    }
  }

  _getPhotos() {
    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${ this.accessToken }&count=${ this.photoCount }&callback=`;
    const photoPromise = $.ajax(url, {
      dataType: 'jsonp',
    });

    return photoPromise.then((response) => {
      if (response.meta.code !== 200) {
        const error = `${ response.meta.error_message } (${ response.meta.error_type })`;
        return $.Deferred().reject(error).promise();
      }

      return response.data;
    });
  }

  _renderPhotos(photos) {
    const photoArray = [];

    const wrapperClass = `instagram--photo-count-${photos.length}`;

    photos.forEach((photo) => {
      const $template = this.$photoTemplate.clone();
      const lowResolution = photo.images.low_resolution;
      const standardResolution = photo.images.standard_resolution;
      const squareSizes = instagramSquared(photo);

      const srcSmall = (this.squareImages ? squareSizes.small : lowResolution.url);
      const srcLarge = (this.squareImages ? squareSizes.large : standardResolution.url);

      const $link = $(`<a target="_blank" href="${ photo.link }"></a>`);
      const $photo = $(`<img src="${ srcSmall }">`);

      if (standardResolution.width >= (lowResolution.width * 2)) {
        $photo.attr('srcset', `${ srcLarge } 2x`);
      } else {
        $photo.attr('src', `${ srcLarge }`); 
      }

      $link.append($photo);
      $template.append($link);

      photoArray.push($template);
    });

    this.$contentPlaceholder.fadeOut(() => {
      this.$wrapper
        .removeClass(this._extractWrapperClass())
        .addClass(wrapperClass);
      this.$photoContainer.append(photoArray);
      this.$contentPlaceholder.remove();
    });
  }
}
